import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { getMarketplaceThirdPartyAuthStateUrl } from '../../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function ThirdPartyAuthStep({
  isPreview,
  name,
  portalId,
  renderedHeaderIcons,
  popUpWindow,
  onPopUpClick,
  installUrl
}) {
  const renderedPopUpCTA = useMemo(() => {
    const returnUrl = getMarketplaceThirdPartyAuthStateUrl(portalId !== null && portalId !== void 0 ? portalId : 0);
    const baseUrl = isPreview ? installUrl || 'https://example-app.com/install' : installUrl;
    if (!baseUrl) {
      return null;
    }
    const url = new URL(baseUrl);
    url.searchParams.set('step', 'authorize');
    url.searchParams.set('returnUrl', returnUrl);
    const popUpUrl = url.toString();
    if (popUpWindow) {
      return /*#__PURE__*/_jsxs(Tile, {
        compact: true,
        padding: "800",
        marginBlockStart: "600",
        children: [/*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.install.thirdPartyStep.loginPage",
            options: {
              name
            }
          })
        }), /*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: () => onPopUpClick(popUpUrl),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.install.thirdPartyStep.openLink"
            })
          })
        })]
      });
    } else {
      return /*#__PURE__*/_jsx(Button, {
        use: "primary",
        marginBlockStart: "600",
        onClick: () => onPopUpClick(popUpUrl),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.install.thirdPartyStep.signIn"
        })
      });
    }
  }, [isPreview, portalId, popUpWindow, onPopUpClick, name, installUrl]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderedHeaderIcons, /*#__PURE__*/_jsx(Text, {
      as: "h1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.install.thirdPartyStep.header",
        options: {
          name
        }
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBlockStart: "300",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.install.thirdPartyStep.subheader",
        options: {
          name
        }
      }), renderedPopUpCTA]
    })]
  });
}